exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{position:relative;width:100%;min-height:calc(100vh - 0.26042rem);overflow:hidden}.fixed-header+.app-main[data-v-078753dd]{padding-top:0.26042rem}.hasTagsView .app-main[data-v-078753dd]{min-height:calc(100vh - 0.4375rem)}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:0.4375rem}\n", ""]);

// exports
